import axios from "axios";
// import { apiConnector } from "../apiconnector";
import {
  setHotelSearch,
  setLoading,
  setErrors,
  resetHotelSearch,
} from "../../slices/hotelSlice";
// import { setErrors } from "../../slices/auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const URL = "https://admin.travelsdata.com/api/Hotel/Search";

export function hotelSearch(searchData, navigate) {

  return async (dispatch) => {
    dispatch(setLoading(true));
    if (searchData && Number(searchData.page) === 1) {
      dispatch(resetHotelSearch());
    }
    try {
      const response = await axios.post(URL, searchData);
    

      if (response.data.success === false) {
        toast.error(response.data.message || "An unexpected error occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        // navigate("/hotel");
      }
      localStorage.setItem("batchKey", response.data.data.batchKey);
      dispatch(setHotelSearch(response.data.data.hotels));
      return response.data.data.hotels;
    } catch (error) {
      
      toast.error(error.message || "An unexpected error occurred", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // navigate("/hotel");
      dispatch(setErrors("Axios Error"));
    }
    dispatch(setLoading(false));
  };
}
